import './home.scss';

import { Steps } from 'intro.js-react';
import React, { useState } from 'react';

import {
  CollectionsWalletList,
  KycModal,
  SettlementHistory,
  TableWrapper,
  TransactionOverview
} from '../../components';
import { dashboardTourSteps, PERMISSIONS } from '../../config';
import { IS_ADMIN } from '../../config';
import { useHasPermission } from '../../hooks';
import { useFetchTransactions } from '../../hooks/queries';

function Home() {
  const { isFetching, recentTransactions } = useFetchTransactions();
  const [enabled, setEnabled] = useState(!window.localStorage.getItem('doneTour') ?? true);
  const initialStep = 0;

  const onExit = () => {
    window.localStorage.setItem('doneTour', 'yes');
    setEnabled(false);
  };

  const onComplete = () => {
    window.localStorage.setItem('doneTour', 'yes');
  };

  const hasPermission = useHasPermission();
  const canViewBalance = hasPermission(PERMISSIONS.BALANCE_VIEW);
  const canViewTransactions = hasPermission(PERMISSIONS.TRANSACTIONS_VIEW);
  const canViewSettlement = hasPermission(PERMISSIONS.SETTLEMENTS_VIEW);

  return (
    <>
      {!IS_ADMIN && (
        <>
          <Steps
            enabled={enabled}
            steps={dashboardTourSteps}
            initialStep={initialStep}
            onExit={onExit}
            options={{ exitOnOverlayClick: false }}
            onComplete={onComplete}
          />
          <KycModal />
        </>
      )}
      <div className="home__wallets">{canViewBalance && <CollectionsWalletList />}</div>
      <div className="home">
        {canViewTransactions && <TransactionOverview />}
        {canViewSettlement && <SettlementHistory />}
        {canViewTransactions && (
          <TableWrapper
            data={recentTransactions}
            isFetching={!recentTransactions.length && isFetching}
            title="Recent"
            name="transactions"
            link="/transactions"
          />
        )}
      </div>
    </>
  );
}

export { Home };
